<template>
  <hm-container>
    <div slot="header">
      <el-radio-group
        v-model="searchConditions.calcStatus"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="计算失败">计算失败</el-radio-button>
        <el-radio-button label="计算成功">计算成功</el-radio-button>
        <!-- <el-radio-button label="computing">计算中</el-radio-button> -->
        <!-- <el-radio-button label="wait">等待计算</el-radio-button> -->
        <el-radio-button label="abnormal">异常预警</el-radio-button>
      </el-radio-group>
      <div class="flex monitor mt10">
        <span class="label">标签数据</span>
        <div class="flex mt10">
          <div class="flex flex-1 labelData">
            <img
              src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-15/1615789237375-926f0970-07a0-4639.png"
              alt=""
            />
            <div class="allLabeles">
              <span class="allLabel">总标签数</span>
              <span class="allLabelData">{{ getLabel.tagCount }}</span>
            </div>
          </div>
          <div class="flex flex-1 labelData">
            <img
              src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-15/1615789237375-926f0970-07a0-4639.png"
              alt=""
            />
            <div class="allLabeles">
              <span class="allLabel">待审核标签</span>
              <span class="allLabelData">{{ getLabel.auditCount }}</span>
            </div>
          </div>
          <div class="flex flex-1 labelData">
            <img
              src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-15/1615789237375-926f0970-07a0-4639.png"
              alt=""
            />
            <div class="allLabeles">
              <span class="allLabel">标签异常预警</span>
              <span class="allLabelData">{{ getLabel.tagWarnsCount }}</span>
            </div>
          </div>
          <div class="flex flex-1 labelData">
            <img
              src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-15/1615792288577-7c1f1946-92de-4207.png"
              alt=""
            />
            <div class="allLabeles">
              <span class="allLabel">埋点数</span>
              <span class="allLabelData">{{ getLabel.eventCount }}</span>
            </div>
          </div>
          <div class="flex flex-1 labelData">
            <img
              src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-15/1615792288577-7c1f1946-92de-4207.png"
              alt=""
            />
            <div class="allLabeles">
              <span class="allLabel">异常埋点</span>
              <span class="allLabelData">{{ getLabel.eventWarnsCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table">
      <div class="flex flex-end mb20">
        <div v-if="searchConditions.calcStatus !== 'abnormal'">
          <el-select
            style="width: 200px"
            size="small"
            clearable
            placeholder="请选择标签分类"
            v-model="searchConditions.tagClassification"
            class="mr10"
            filterable
          >
            <el-option
              v-for="(v, i) in tagClassificationList"
              :key="i"
              :label="v.name"
              :value="v.value"
            ></el-option>
          </el-select>
          <el-select
            style="width: 200px"
            size="small"
            clearable
            placeholder="请选择更新方式"
            v-model="searchConditions.updateWay"
            class="mr10"
            filterable
          >
            <el-option
              v-for="(v, i) in updateWayList"
              :key="i"
              :label="v.name"
              :value="v.value"
            ></el-option>
          </el-select>
          <el-select
            style="width: 200px"
            size="small"
            clearable
            placeholder="请选择运行状态"
            v-model="searchConditions.runcalcStatus"
            class="mr10"
            filterable
          >
            <el-option
              v-for="(v, i) in runcalcStatusList"
              :key="i"
              :label="v.name"
              :value="v.value"
            ></el-option>
          </el-select>
        </div>
        <el-input
          size="small"
          class="mr10"
          v-model="searchConditions.tagName"
          placeholder="请输入标签名称"
        ></el-input>
        <el-button size="small" type="primary" @click="paging(1)"
          >查询</el-button
        >
      </div>
      <el-table
        v-if="searchConditions.calcStatus !== 'abnormal'"
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="标签名称"
          prop="tagName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="覆盖数量"
          prop="calcCount"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="运行状态">
          <template v-slot="scope">
            <span class="success" v-if="scope.row.auditState === 'yes'"
              >运行中</span
            >
            <span class="gray" v-else>未运行</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="更新方式"
          prop="tagUpdateTimeTypeFormat"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="最后一次计算时间"
          prop="updateTime"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="单次计算时间"
          prop="calcTime"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="最后计算状态"
        >
          <template v-slot="scope">
            <span
              v-if="scope.row.calcStatus === 'success'"
              :class="scope.row.calcStatus | calcClassName"
              >计算成功</span
            >
            <span
              v-else-if="scope.row.calcStatus === 'fail'"
              :class="scope.row.calcStatus | calcClassName"
            >
              计算失败
            </span>
            <span v-else :class="scope.row.calcStatus | calcClassName">
              等待计算
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              class="blue"
              @click="toDetails(scope.row)"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-else
        :data="abNormalList"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="标签名称"
          prop="tagName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="异常描述"
          prop="warnsDesc"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="异常时间"
          prop="responseTime"
        ></el-table-column>
        <!-- <el-table-column header-align="center" align="center" label="操作">
          <template v-slot="scope">
            <el-button type="text" @click="removeException(scope.row)"
              >解除异常</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-container>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      list: [],
      abNormalList: [],
      countList: {
        totalCount: 0,
        failCount: 0,
        succCount: 0,
        computingCount: 0,
        waitCount: 0
      },
      currentPage: 1,
      getLabel: {},
      pageSize: 10,
      searchConditions: {
        calcStatus: "",
        tagName: ""
      },
      tagClassificationList: [
        {
          name: "全部",
          value: ""
        },
        {
          name: "用户标签",
          value: "user"
        },
        {
          name: "商品标签",
          value: "goods"
        }
      ],
      runcalcStatusList: [
        {
          name: "全部",
          value: ""
        },
        {
          name: "运行中",
          value: "running"
        },
        {
          name: "未运行",
          value: "notRun"
        }
      ],
      updateWayList: [
        {
          name: "全部",
          value: ""
        },
        {
          name: "每小时更新",
          value: "hour"
        },
        {
          name: "每天更新",
          value: "day"
        },
        {
          name: "每周更新",
          value: "week"
        },
        {
          name: "每月更新",
          value: "month"
        },
        {
          name: "每年更新",
          value: "year"
        }
      ]
    };
  },
  created() {
    this.queryList();
    this.queryLabel();
  },
  mounted() {},
  filters: {
    calcClassName(val) {
      let className = "";
      switch (val) {
        case "success":
          className = "success";
          break;
        case "fail":
          className = "danger";
          break;

        default:
          className = "gray";
          break;
      }
      return className;
    }
  },
  methods: {
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryLabel() {
      const { result } = await this.$store.dispatch("queryLoopLabel", {});
      this.getLabel = result;
    },
    async queryList() {
      let actionName = "queryTagMonitor";
      if (this.searchConditions.calcStatus === "abnormal") {
        actionName = "queryTagWarnList";
      }
      const { result } = await this.$store.dispatch(actionName, {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        ...this.searchConditions
      });
      const { records, total } = result;
      if (records) {
        this.list = records;
        this.list.forEach(v => {
          v.tagUpdateTimeTypeFormat = this.updateWayList.find(
            o => o.value === v.tagUpdateTimeType
          ).name;
        });
        this.total = total;
      } else {
        this.abNormalList = result;
      }
    },
    removeException(row) {},
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    toDetails(row) {
      this.$router.push({
        name: "TagDetails",
        query: {
          id: row.id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.monitor {
  flex-direction: column;
  .label {
    font-size: 16px;
    color: #222222;
  }
  .labelData {
    display: flex;
    margin-left: 20px;
    img {
      width: 60px;
      height: 60px;
    }
    .allLabeles {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      .allLabel {
        font-size: 14px;
        color: #222222;
        font-weight: 400;
      }
      .allLabelData {
        font-size: 24px;
        color: #222222;
        font-weight: 600;
        margin-top: 5px;
      }
    }
  }
}
</style>
